<template>
  <div>
    <gui-multi-select
        :modelValue="modelValue"
        @update:modelValue="e=>$emit('update:modelValue', e)"
        placeholder="Выберите приложение"
        :label="label"
        :error="error"
        :hilightOn="hilightOn"
        textField="name"
        :w="w"
        :sm="sm"
        :list="list"/>
  </div>
</template>

<script>
export default {
  name: 'gui-application-multi-select',
  data() {
    return {
      list: [],
    }
  },
  props: {
    label: String,
    error: [String, Object, Array],
    hilightOn: [Array, String, Number],
    modelValue: {
      type: [Array],
    },
    w: Boolean,
    sm: Boolean,
  },
  mounted() {
    this.loadList();
  },
  methods: {
    loadList() {
      axiosGetValue('/api/admin/application/widget', {}, e => {
        this.list = e
      })
    },
  }
}
</script>